import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmRemoveDialog from "./ConfirmRemoveDialog";

const GroupDialog = ({ groupData, close, fetchGroups, createGroup, updateGroup, deleteGroup, fetchRows }) => {
  const [name, setName] = useState(groupData.name || "");
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const { t } = useTranslation();

  const save = async () => {
    if (!name.trim()) return;

    const action = groupData.id ? updateGroup(groupData.id, { name }) : createGroup({ name });

    try {
      await action;
      fetchGroups();
      close();
    } catch (error) {
      console.error("Error saving group:", error);
    }
  };

  const remove = () => {
    setShowConfirmDialog(true);
  };

  const confirmRemove = async () => {
    try {
      await deleteGroup(groupData.id);
      await fetchRows();
      fetchGroups();
      close();
    } catch (error) {
      console.error("Error deleting group:", error);
    } finally {
      setShowConfirmDialog(false);
    }
  };

  return (
    <div className="dialog">
      <div className="dialog-content">
        <div className="close" onClick={close}></div>
        <div className="form-group">
          <label htmlFor="groupName">{t("teams.group_name")}</label>
          <input
            id="groupName"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="form-container-actions">
          {groupData.id && (
            <button className="button button-dialog-delete" onClick={remove}>
              {t("buttons.common.delete")}
            </button>
          )}
          <div className="flex-end">
            <button className="button" onClick={close}>{t("buttons.common.cancel")}</button>
            <button className="button button-primary" onClick={save}>
              {groupData.id ? t("buttons.common.update") : t("buttons.common.save")}
            </button>
          </div>
        </div>
      </div>

      {showConfirmDialog && (
        <ConfirmRemoveDialog
          title={t("teams.remove_group", { title: name })}
          confirm={confirmRemove}
          close={() => setShowConfirmDialog(false)}
        />
      )}
    </div>
  );
};
 
export default GroupDialog;
